module.exports = __webpack_public_path__ + "static/media/icons_Bilan du Rachis Cervical - CAD.3adadc10.svg";